import {uuid} from "@/interfaces";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface TypingState {
    byRoom: Record<uuid, Record<uuid, { typing: boolean; ts: number }>>;
    unread: Record<uuid, number>;
}

const initialState: TypingState = {
    byRoom: {},
    unread: {},
};

const slice = createSlice({
    name: "realtime",
    initialState,
    reducers: {
        setTyping(
            state,
            action: PayloadAction<{
                roomId: uuid;
                userId: uuid;
                typing: boolean;
                ts: number;
            }>,
        ) {
            const { roomId, userId, typing, ts } = action.payload;
            state.byRoom[roomId] ??= {};
            state.byRoom[roomId][userId] = { typing, ts };
        },

        incrementUnread(state, action: PayloadAction<uuid>) {
            const id = action.payload;
            state.unread[id] = (state.unread[id] || 0) + 1;
        },

        resetUnread(state, action: PayloadAction<uuid>) {
            delete state.unread[action.payload];
        },
    }
});

export const { setTyping, incrementUnread, resetUnread } = slice.actions;
export default slice.reducer;